import styled, { keyframes } from 'styled-components';
import dataAward from "./awards/data-award.json";
import AwardCard from "./component/AwardCard";

const Icon = styled.img`
  width: 80px;
  height: 80px;
`;

const float = keyframes`
  0% { transform: translateY(0) translateX(0); opacity: 0.8; }
  50% { transform: translateY(-20px) translateX(10px); opacity: 0.4; }
  100% { transform: translateY(0) translateX(0); opacity: 0.8; }
`;

const FloatingIcon = styled.img`
  position: absolute;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  width: ${(props) => props.size};
  animation: ${float} ${(props) => props.duration} ease-in-out infinite;
  pointer-events: none;
  opacity: 0.6;
  z-index: 1;
`;

const BGWrapper = styled.div`
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  background: linear-gradient(135deg, #f7f7f7, #e2ecf4);
`;

const Container = styled.div`
    margin: 0 auto;
    padding: 0px;
`;

const AwardsPage = () => {

    const icons = [
        { src: 'assets/icon/icon-apple-book.png', top: '10%', left: '5%', size: '70px', duration: '9s' },
        { src: 'assets/icon/icon-light.png', top: '50%', left: '90%', size: '50px', duration: '8s' },
        { src: 'assets/icon/icon-book.png', top: '80%', left: '10%', size: '35px', duration: '9s' },
        { src: 'assets/icon/icon-education.png', top: '15%', left: '80%', size: '35px', duration: '9s' },
        { src: 'assets/icon/icon-certificate.png', top: '80%', left: '20%', size: '125px', duration: '12s' },
        { src: 'assets/icon/icon-bag.png', top: '10%', left: '90%', size: '60px', duration: '9s' },
        { src: 'assets/icon/icon-paint.png', top: '65%', left: '20%', size: '80px', duration: '9s' },
        { src: 'assets/icon/icon-pencil.png', top: '85%', left: '85%', size: '100px', duration: '9s' }
    ];

    return (
        <Container>
            {/* {icons.map((icon, idx) => (
                <FloatingIcon key={idx} {...icon} />
            ))} */}
            <div className="min-h-screen flex justify-center">
                <div className="w-full">
                    <h1 className="px-6 text-3xl font-bold mb-6">App Launch Highlights</h1>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {dataAward.map((award) => (
                            award.visible ? <AwardCard key={award.id} award={award} /> : <></>
                        ))}
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default AwardsPage;